import { createSlice } from "@reduxjs/toolkit";

//STATE
const state = {
  rows: [],
  showDialog: false,
  isLoading: false,
};

//STORE SLICE
export const itemTypesAddSlice = createSlice({
  name: "itemTypesAddSlice",
  initialState: state,
  //REDUCER
  reducers: {
    showAddItemTypesDialog(state) {
      return {
        ...state,
        showDialog: true,
      };
    },
    closeAddItemTypesDialog(state) {
      return {
        ...state,
        showDialog: false,
      };
    },
    showLoading(state) {
      return {
        ...state,
        isLoading: true,
      };
    },
    hideLoading(state) {
      return {
        ...state,
        isLoading: false,
      };
    },    
  },
});

//ACTIONS
export const {
  showAddItemTypesDialog,
  closeAddItemTypesDialog,
  showLoading,
  hideLoading
} = itemTypesAddSlice.actions;

export default itemTypesAddSlice.reducer;
